// extracted by mini-css-extract-plugin
export default {"move-inspiration-modal-content":"index_move-inspiration-modal-content__mrqfq","mn-inspiration-image-modal":"index_mn-inspiration-image-modal__idj0o"};